<template>
<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.29304 6.29285L7.29304 0.292847L8.70726 1.70706L4.41436 5.99995H17.0002C17.5524 5.99995 18.0002 6.44767 18.0002 6.99995C18.0002 7.55224 17.5524 7.99995 17.0002 7.99995H4.41436L8.70726 12.2928L7.29304 13.7071L1.29304 7.70706L0.585938 6.99995L1.29304 6.29285Z" fill="#FF3C8A"/>
</svg>
</template>
